import React, { Component } from "react";
import "../../styles/components/Sliders/Slider.css";
import { FaArrowCircleLeft, FaArrowCircleRight } from "react-icons/fa";
import NextSliders from "./NextSliders";

const scrollRec = (range, element, direction) => {
  console.log(range);
  let diff = 20;
  if (range - 20 < 0) {
    diff = range;
  }

  if (range <= 0) {
    return;
  } else {
    console.log(diff, "diff");
    if (direction === "right") {
      setTimeout(() => {
        element.scrollLeft += diff;
        range -= 20;
        scrollRec(range, element, direction);
      }, 5);
    } else {
      setTimeout(() => {
        element.scrollLeft -= diff;
        range -= 20;
        scrollRec(range, element, direction);
      }, 5);
    }
  }
};

const scroll = direction => {
  var width = document.getElementById("dafuq").offsetWidth;
  var element = document.getElementById("slider");

  scrollRec(width, element, direction);
};

class Slider extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    return (
      <div className="slider-wrapper">
        <div className="slider-left-section">
          <a
            href
            onClick={() => {
              scroll("left");
            }}
          >
            <FaArrowCircleLeft
              size={40}
              color={"#38598b"}
              className="go-left"
            />
          </a>
        </div>
        <div className="page-sliders" id="slider">
          <div id="dafuq" className="first-slider-middle-section">
            <div className="main-slider-section">
              <img
                src="https://cdn.exit.al/wp-content/uploads/2019/07/11153650/komisioni-hetimor.jpg"
                className="photo-main-wrapper"
                alt=""
              />

              <div className="text-section">
                <a href>Komisioni kryesor</a>
                <div className="more-details">
                  RENDI I DITËS 03.08.2019, ORA 10:00 Komisioni Qendror i
                  Zgjedhjeve, ditën e shtunë, më datë 03.08.2019, ora 10:00,
                  zhvillon mbledhjen me këtë rend dite: Shqyrtimi i projekt
                  vendimi: Për shqyrtimin e kërkesës paraqitur nga partia
                  Republikane e Shqipërisë, partia Agrare Ambjentaliste e
                  Shqipërisë dhe partia Lëvizja Socialiste për Integrim “Për
                  fillimin e procedurave për zgjedhjet për organet e qeverisjes
                  vendore të
                </div>
              </div>
            </div>
            <div className="more-slider-section">
              <div className="top-section">
                <div className="news-top-left">
                  <img
                    src="https://cdn.exit.al/wp-content/uploads/2019/07/11153650/komisioni-hetimor.jpg"
                    className="photo-wrapper"
                    alt=""
                  />
                  <a href>Komisioni</a>
                </div>
                <div className="news-top-right">
                  <img
                    src="https://cdn.exit.al/wp-content/uploads/2019/07/11153650/komisioni-hetimor.jpg"
                    className="photo-wrapper"
                    alt=""
                  />
                  <a href>Komisioni</a>
                </div>
              </div>
              <div className="bottom-section">
                <div className="news-bottom-left">
                  <img
                    src="https://cdn.exit.al/wp-content/uploads/2019/07/11153650/komisioni-hetimor.jpg"
                    className="photo-wrapper"
                    alt=""
                  />
                  <a href>Komisioni</a>
                </div>
                <div className="news-bottom-right">
                  <img
                    src="https://cdn.exit.al/wp-content/uploads/2019/07/11153650/komisioni-hetimor.jpg"
                    className="photo-wrapper"
                    alt=""
                  />
                  <a href>Komisioni</a>
                </div>
              </div>
            </div>
          </div>
          <NextSliders />
          <NextSliders />
        </div>

        <div className="slider-right-section">
          <a
            href
            onClick={() => {
              scroll("right");
            }}
          >
            <FaArrowCircleRight
              size={40}
              color={"#38598b"}
              className="go-right"
            />
          </a>
        </div>
      </div>
    );
  }
}
export default Slider;
